@if (isLoading) {
<app-loader></app-loader>
} @else if (dataSource.data.length > 0) {
<div class="user-property-list-table-container">
    <div style="width:100%; display:flex; flex-direction: row; justify-content: space-between; align-items: center;">
        <div>
            <h3>Email Logs</h3>
        </div>
        <div>
            <button mat-flat-button class="metallic-text-btn-blue" (click)="createEmail()">
                <mat-icon>add</mat-icon>
                Create Email
            </button>
        </div>
    </div>
  <div class="mat-elevation-z8 hide-on-mobile">

    <mat-table [dataSource]="dataSource" matSort matSortActive="createdAt" matSortDirection="desc"> 

      <ng-container matColumnDef="templateId">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Type </mat-header-cell>
        <mat-cell *matCellDef="let log"> 
            <mat-icon color="primary" [matTooltip]="templates[log.templateId].name">info</mat-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="senderName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Sender </mat-header-cell>
        <mat-cell *matCellDef="let log"> {{ log.senderName ?? '' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="sendToName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
        <mat-cell *matCellDef="let log"> {{ log.sendToName ?? '' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="sendToEmail">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Email </mat-header-cell>
        <mat-cell *matCellDef="let log"> {{ log.sendToEmail ?? '' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
        <mat-cell *matCellDef="let log"> {{ log.status ?? '' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="isOpened">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Opened </mat-header-cell>
        <mat-cell *matCellDef="let log"> {{ log.isOpened ?? '' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="clickCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Click Count </mat-header-cell>
        <mat-cell *matCellDef="let log"> {{ log.clickCount ?? '' }} </mat-cell>
      </ng-container>

      <!-- <ng-container matColumnDef="url">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Document </mat-header-cell>
        <mat-cell *matCellDef="let form">
          <ng-container *ngIf="form.formUrl as url; else noLink">
            <a [href]="url" target="_blank" rel="noopener noreferrer">
              View / Download
              <mat-icon inline="true" aria-hidden="false" aria-label="open in new tab">open_in_new</mat-icon>
            </a>
          </ng-container>
          <ng-template #noLink>
            <span *ngIf="form.formUrl" class="text-muted">No presigned link available</span>
            <span *ngIf="!form.formUrl" class="text-muted">—</span>
          </ng-template>
        </mat-cell>
      </ng-container> -->

      <ng-container matColumnDef="updatedAt">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Updated </mat-header-cell>
        <mat-cell *matCellDef="let log"> {{ log.updatedAt | date: 'M/dd/yyyy h:MM a' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Created </mat-header-cell>
        <mat-cell *matCellDef="let log"> {{ log.createdAt | date: 'M/dd/yyyy h:MM a' }} </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>


  </div>

  <div class="mobile-property-list show-on-mobile" *ngIf="!isLoading">
    <mat-card *ngFor="let log of dataSource.connect() | async" class="mobile-property-card">
      <mat-card-content>
        <div>{{ log.senderName }} to {{ log.sendToName }}</div>
        <div>{{ log.subjectInput }}</div>
        <div>{{ log.status }}</div>
        <div>
          <div>Last Updated: {{ log.updatedAt | date: 'M/dd/yyyy h:MM a' }}</div>
          <div>Created: {{ log.createdAt | date: 'M/dd/yyyy h:MM a' }}</div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <mat-paginator #paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of forms">
  </mat-paginator>
</div>
} @else {
<p>No email logs found</p>
}